import React, { useEffect, useState,forwardRef, useImperativeHandle } from "react";
import { GoogleMap, useLoadScript, Marker } from "@react-google-maps/api";
import "./GoogleMaps.css";
import { Img } from "components/Img";
//import GlobalDrawer from "components/Drawer";
import GlobalDrawer from  "components/New Drawer/NewDrawer"
// import Input from "components/Input";
import { Search, Crosshair, MapPin } from 'lucide-react';
import {LocationInput} from "components/NewInput";
export interface Location {
  lat: number;
  lng: number;
  address: string | null;
  state?: string | null;
  city?: string | null;
  postalCode?: string | null;
  place_id?: string | null;
  country?: string | null;
  label?: string;
  isError?: boolean;
}

export interface GoogleMapsRef {
  openDrawer: () => void;
}

interface GoogleMapsProps {
  onLocationClick: (location: Location) => void;
  selectedLocation: Location | null;
  initialLocation: Location | null;
  disable?: boolean;
  label?: boolean;
  isError?: boolean;
}



export const GoogleMaps = forwardRef<GoogleMapsRef, GoogleMapsProps>(({
  onLocationClick,
  selectedLocation,
  initialLocation,
  disable,
  label,
  isError,
}, ref) => {

  const { isLoaded, loadError } = useLoadScript({
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_API_KEY,
  });

  const [currentLocation, setCurrentLocation] = useState<Location | null>(
    initialLocation
  );
  const [marker, setMarker] = useState<google.maps.Marker | null>(null);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [searchLocation, setSearchLocation] = useState("");
  const [isGettingLocation, setIsGettingLocation] = useState(false);

  useImperativeHandle(ref, () => ({
    openDrawer: () => {
      setDrawerOpen(true);
    }
  }));
  
  const handleFieldChange = (field: keyof Location, value: string) => {
  setCurrentLocation(prev => ({
    ...(prev || ({} as Location)),
    [field]: value,
  }));
};
  const handleMapClick = (e: google.maps.MapMouseEvent) => {
    if (!disable) {
      if (e.latLng) {
        const lat = e.latLng.lat();
        const lng = e.latLng.lng();
        const geocoder = new window.google.maps.Geocoder();
        geocoder.geocode({ location: { lat, lng } }, (results, status) => {
          if (status === "OK" && results && results[0]) {
            const formattedAddress = results[0].formatted_address;
            let place_id = results?.[0]?.place_id;
            let city = "";
            let postalCode = "";
            let country = "";
            let state = "";
            results?.[0]?.address_components.forEach((component) => {
              // if (component.types.includes('locality')) {
              //   city = component.long_name; // Direct city name
              // }
              if (component.types.includes("postal_code")) {
                postalCode = component.long_name; // Postal Code
              }
              if (component.types.includes("country")) {
                country = component.long_name; // Country Name
              }
              if (component.types.includes("administrative_area_level_3")) {
                city = component.long_name; // District-level city
              }
              if (component.types.includes("administrative_area_level_1")) {
                state = component.long_name;
              }
            });

            const clickedLocation: Location = {
              lat,
              lng,
              address: formattedAddress,
              state,
              country,
              postalCode,
              city,
              place_id,
            };
            onLocationClick(clickedLocation);

            setCurrentLocation(clickedLocation);

            if (marker) {
              marker.setPosition({ lat, lng });
            } else {
              const newMarker = new window.google.maps.Marker({
                position: { lat, lng },
                title: formattedAddress,
              });
              setMarker(newMarker);
            }
          } else {
            console.error("Geocoder failed due to: " + status);
          }
        });
      } else {
        console.error("e.latLng is null");
      }
    }
  };

  const handleUseMyLocation = () => {
    if (navigator.geolocation) {
      setIsGettingLocation(true);
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const { latitude, longitude } = position.coords;
          const geocoder = new window.google.maps.Geocoder();
          geocoder.geocode({ location: { lat: latitude, lng: longitude } }, (results, status) => {
            setIsGettingLocation(false);
            if (status === "OK" && results && results[0]) {
              const formattedAddress = results[0].formatted_address;
            //  console.log("🏠 4. Raw Geocoder Address Components:", results[0].address_components);
              let place_id = results?.[0]?.place_id;
              let city = "";
              let postalCode = "";
              let country = "";
              let state = "";
              results?.[0]?.address_components.forEach((component) => {
                if (component.types.includes("postal_code")) {
                  postalCode = component.long_name;
                }
                if (component.types.includes("country")) {
                  country = component.long_name;
                }
                if (component.types.includes("administrative_area_level_3")) {
                  city = component.long_name;
                }
                if (component.types.includes("administrative_area_level_1")) {
                  state = component.long_name;
                }
              });

              const myLocation: Location = {
                lat: latitude,
                lng: longitude,
                address: formattedAddress,
                state,
                country,
                postalCode,
                city,
                place_id,
              };
             
              onLocationClick(myLocation);
              setCurrentLocation(myLocation);
              

              if (marker) {
                marker.setPosition({ lat: latitude, lng: longitude });
              } else {
                const newMarker = new window.google.maps.Marker({
                  position: { lat: latitude, lng: longitude },
                  title: formattedAddress,
                });
                setMarker(newMarker);
              }
            } else {
              const basicLocation: Location = {
                lat: latitude,
                lng: longitude,
                address: null,
              };
              onLocationClick(basicLocation);
              setCurrentLocation(basicLocation);

              if (marker) {
                marker.setPosition({ lat: latitude, lng: longitude });
              } else {
                const newMarker = new window.google.maps.Marker({
                  position: { lat: latitude, lng: longitude },
                  title: "My Location",
                });
                setMarker(newMarker);
              }
            }
          });
        },
        (error) => {
          setIsGettingLocation(false);
          console.error("Error getting current location:", error);
          alert("Unable to get your location. Please check your browser settings and try again.");
        }
      );
    } else {
      console.error("Geolocation is not supported in this browser.");
      alert("Geolocation is not supported in this browser.");
    }
    
  };
//   useEffect(() => {
//   console.log("Checking API Key Configuration...");
//   if (!process.env.REACT_APP_GOOGLE_API_KEY) {
//     console.error("API Key is MISSING from your .env file!");
//   } else {
//     console.log("API Key found in environment variables.");
//   }
// }, []);

  useEffect(() => {
    if (selectedLocation) {
      if (marker) {
        const { lat, lng } = selectedLocation;
        marker.setPosition({ lat, lng });
      }
    }
  }, [selectedLocation, marker]);

  if (loadError) {
    return <div>Error loading Google Maps</div>;
  }

  const handleOpenDrawer = () => {
    setDrawerOpen(drawerOpen => true);
  };

  const handleCloseDrawer = () => {
    setSearchLocation(searchLocation => "");
    setDrawerOpen(drawerOpen => false);
  };

  const handleReset = () => {
    setSearchLocation(searchLocation => "");
    setCurrentLocation(currentLocation => "" as any);
    onLocationClick("" as any);

    if (marker) {
      marker.setMap(null); // Remove marker from map
      setMarker(null); // Clear marker state
    }

    handleCloseDrawer()
  };

  const handleSaveLocation = () => {
 
  if (!currentLocation) {
    handleCloseDrawer();
    return;
  }


  const addressParts = [
    currentLocation.address,
    currentLocation.city,
    currentLocation.state,
    currentLocation.postalCode,
    currentLocation.country
  ].filter(Boolean); 

  const uniqueParts = Array.from(new Set(addressParts));
  const combinedAddress = uniqueParts.join(", ");

  const finalLocation: Location = {
    ...currentLocation,     
    address: combinedAddress, 
    lat: currentLocation.lat || 0,
    lng: currentLocation.lng || 0,
  };

 
  onLocationClick(finalLocation);

  handleCloseDrawer();
};
  const handleSearch = () => {
    if (!searchLocation.trim()) return;

    const geocoder = new window.google.maps.Geocoder();
    geocoder.geocode({ address: searchLocation }, (results, status) => {
      if (status === "OK" && results && results[0]) {
        const place = results[0];
        const lat = place.geometry?.location?.lat();
        const lng = place.geometry?.location?.lng();

        if (lat && lng) {
          let city = "";
          let postalCode = "";
          let country = "";
          let state = "";

          place.address_components.forEach((component) => {
            if (component.types.includes("postal_code")) {
              postalCode = component.long_name;
            }
            if (component.types.includes("country")) {
              country = component.long_name;
            }
            if (component.types.includes("administrative_area_level_3")) {
              city = component.long_name;
            }
            if (component.types.includes("administrative_area_level_1")) {
              state = component.long_name;
            }
          });

          const searchedLocation: Location = {
            lat,
            lng,
            address: place.formatted_address,
            state,
            country,
            postalCode,
            city,
          };

          onLocationClick(searchedLocation);
          setCurrentLocation(searchedLocation);

          if (marker) {
            marker.setPosition({ lat, lng });
          } else {
            const newMarker = new window.google.maps.Marker({
              position: { lat, lng },
              title: place.formatted_address,
            });
            setMarker(newMarker);
          }
        }
      } else {
        console.error("Geocoder failed due to:", status);
      }
    });
  };

  return (
     
    <div className="self-center  w-full h-full">   
      <button type="button" onClick={handleOpenDrawer} className={`flex gap-2 ${isError ? "text-red-700" : "text-blue-700"} w-full h-full  justify-center items-center `}  >
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#000000" stroke-width="1" stroke-linecap="round" stroke-linejoin="round">
  <polygon points="3 6 9 3 15 6 21 3 21 18 15 21 9 18 3 21" />
  <line x1="9" y1="3" x2="9" y2="18" />
  <line x1="15" y1="6" x2="15" y2="21" />
</svg>
      </button>
      <GlobalDrawer
        open={drawerOpen}
        onClose={handleCloseDrawer}
        drawerHeading={label || `Locate Institute On Map`}
        width={'55vh'}
      
        //styles={{ body: { padding: 0 }, }}
      >
        <div className="googleMapContinerStyle  ">
          {!isLoaded ? (
            <h1>Loading...</h1>
          ) : (
            <>
             
              <GoogleMap
                mapContainerClassName="googleMapContainerStyleHandler"
                center={
                  selectedLocation
                    ? selectedLocation
                    : currentLocation
                      ? currentLocation
                      : { lat: 18.52043, lng: 73.856743 }
                }
                zoom={currentLocation ? 16 : 6}
                onClick={handleMapClick}
                options={{
                  disableDefaultUI:true, // Hide default controls
                  draggable: !disable, // Disable dragging
                  zoomControl: false, // Disable zoom controls
                  scrollwheel: !disable, // Disable zooming with scroll
                  disableDoubleClickZoom: disable, // Disable zooming on double click
                  keyboardShortcuts: !disable, // Disable keyboard interactions
                  clickableIcons: !disable,
                  fullscreenControl: false,
                }}
                
              >
                {selectedLocation ? (
                  <Marker
                    position={{
                      lat: selectedLocation.lat,
                      lng: selectedLocation.lng,
                    }}
                    title={selectedLocation.address || ""}
                    onLoad={(marker) => setMarker(marker)}
                  />
                ) : (
                  currentLocation && (
                    <Marker
                      position={{
                        lat: currentLocation.lat,
                        lng: currentLocation.lng,
                      }}
                      title={currentLocation.address || ""}
                      onLoad={(marker) => setMarker(marker)}
                    />
                  )
                )}

                 {!disable && (
                <div className="flex items-center gap-4 m-0 ">
                  <div className="absolute top-4 left-4 right-4 flex items-center justify-between gap-3 z-10 ">
                     <div className="flex-1 bg-white box-border  rounded-[5px] shadow-[0_4px_4px_0_rgba(0,0,0,0.25)] flex items-center px-2  h-[4.5vh] border border-[#9d9d9d]" style={{ backgroundColor: '#fff' }} >
           <Search className="w-[2.2vh] h-[2.2vh] text-[#000]  flex-shrink-0 "
           
           onClick={handleSearch}/>
          
         <input
                      disabled={disable}
                      className="rounded-lg w-full  font-inter  font-[400] px-2 md:text-sm placeholder-[#000] focus:outline-none focus:ring-0 focus:border-transparent"
                      placeholder={"Search ..."}
                     onKeyDown={(e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      handleSearch();     
    }
  }}
                      style={{
                        backgroundColor: "white",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        fontSize: "2.2vh",
                        fontFamily:"inter",
                        fontWeight:"400"
                       
                      }}
                      value={searchLocation}
                      onChange={(item) => {
                        setSearchLocation(searchLocation => item.target.value);
                      }}
                    />
                     </div>
                     <button className="bg-white  py-2.5 rounded-[5px] shadow-[0_4px_4px_0_rgba(0,0,0,0.25)] flex items-center justify-center p-1 gap-1 text-xs font-semibold text-[#000] hover:bg-gray-50 transition-colors border border-gray-400 whitespace-nowrap w-[40%] h-[4.5vh]" style={{ backgroundColor: '#fff' }} onClick={handleUseMyLocation} disabled={disable || isGettingLocation}>
                       {isGettingLocation ? (
                    <>
                      <svg className="animate-spin h-3 w-3 text-blue-700" viewBox="0 0 24 24">
                        <circle
                          className="opacity-25"
                          cx="12"
                          cy="12"
                          r="10"
                          stroke="currentColor"
                          strokeWidth="4"
                        ></circle>
                        <path
                          className="opacity-75"
                          fill="currentColor"
                          d="M4 12a8 8 0 018-8v8z"
                        ></path>
                      </svg>
                      Getting Location...
                    </>
                  ) : (
                    <>
            <svg
      className="w-3.5 h-3.5 text-[#000] "
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="12" cy="12" r="7" stroke="currentColor" strokeWidth="2.5" />
      <circle cx="12" cy="12" r="3" fill="currentColor" />
      <path d="M12 1V5M12 19V23M1 12H5M19 12H23" stroke="currentColor" strokeWidth="2.5" />
    </svg>
            <span className=" font-inter  font-[400] text-[2.2vh]">Locate me</span>
            
            </>
                  )}
            
          </button>

                  </div>
                 

                  
                  {/* <button
                    onClick={handleUseMyLocation}
                    type="button"
                    disabled={disable || isGettingLocation}
                    style={{ color: '#fff' }}
                    className="py-2 px-4 text-[2.2vh] font-medium text-[white] bg-green-600 rounded-lg hover:bg-green-700 focus:ring-4 focus:ring-green-300 focus:outline-none disabled:opacity-50"
                  >
                    {isGettingLocation ? "Getting..." : "Use My Location"}
                  </button> */}
                </div>
              )}
              </GoogleMap>

              {!disable && (
                <div className="px-6 pt-4 pb-2 bg-white h-full flex flex-col gap-y-[1.5vh]">
                  {/* Street Address */}
                  <LocationInput
                    label="Street address"
                    placeholder="Street address, city, 122342"
                    value={currentLocation?.address || ""}
                    onChange={(e: any) =>
                      handleFieldChange("address", e?.target ? e.target.value : e)
                    }
                  />

                  {/* City & State */}
                  <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "16px" }}>
                    <LocationInput
                      label="City"
                      placeholder="City"
                      value={currentLocation?.city || ""}
                      onChange={(e: any) =>
                        handleFieldChange("city", e?.target ? e.target.value : e)
                      }
                    />
                    <LocationInput
                      label="State / Province"
                      placeholder="State"
                      value={currentLocation?.state || ""}
                      onChange={(e: any) =>
                        handleFieldChange("state", e?.target ? e.target.value : e)
                      }
                    />
                  </div>

                  {/* Zip & Country */}
                  <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "16px" }}>
                    <LocationInput
                      label="Zip/ postal code"
                      placeholder="524301"
                      value={currentLocation?.postalCode || ""}
                      onChange={(e: any) =>
                        handleFieldChange("postalCode", e?.target ? e.target.value : e)
                      }
                    />
                    <LocationInput
                      label="Country"
                      placeholder="India"
                      value={currentLocation?.country || ""}
                      onChange={(e: any) =>
                        handleFieldChange("country", e?.target ? e.target.value : e)
                      }
                    />
                  </div>

                  {/* Actions */}
                  <div className="pt-2 flex flex-col gap-3 pb-2 mt-auto">
                    <button
                      onClick={handleSaveLocation}
                      style={{ color: "#fff" }}
                      className="w-full bg-[#3b49df] hover:bg-blue-700 !text-white text-[2.3vh] font-inter font-400 rounded-[6px] transition-colors border-none outline-none focus:ring-4 focus:ring-blue-300 h-[4.5vh] flex items-center justify-center gap-2"
                    >
                      Next
                    </button>
                    <button
                      onClick={handleReset}
                      className="w-full !bg-white !text-black text-[2.3vh] font-inter font-400 rounded-[10px] hover:bg-gray-50 transition-colors border-none shadow-none outline-none h-[4.5vh] flex items-center justify-center gap-2 border border-gray-400"
                    >
                      Cancel
                    </button>
                  </div>
                </div>
              )}
            </>
          )}
        </div>
      </GlobalDrawer>
    </div>
  );
});